import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from 'react';
import { api } from '../api/client';
import { posthog } from '../posthog';
export const AuthContext = createContext(undefined);
export function AuthProvider({ children }) {
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(true);
    const refresh = async () => {
        try {
            const me = await api.authMe();
            setPlayer(me);
            if (me?.id)
                posthog.identify(String(me.id), { is_admin: me.is_admin });
        }
        catch (err) {
            const status = err.status;
            if (status === 401) {
                setPlayer(null);
            }
            else {
                // Network or 5xx — leave existing state, log
                console.error('auth refresh failed', err);
            }
        }
        finally {
            setLoading(false);
        }
    };
    const logout = async () => {
        await api.authLogout();
        setPlayer(null);
        posthog.reset();
    };
    useEffect(() => {
        refresh();
    }, []);
    return (_jsx(AuthContext.Provider, { value: { player, loading, refresh, logout }, children: children }));
}
